module.exports = __webpack_public_path__ + "static/media/ucon11.0f7e07c3.JPG";